/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
import axios from 'axios';
import moment from 'moment';
import { baseURL } from '../constants';
import { authHeader } from '../redux/helper/auth-header';

async function Getprofile() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/distributors/distributor/get/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function UpdateDistributor(payload) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.patch(`${baseURL}/distributors/update/${ACCOUNT_NUMBER}`, payload, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function Getaddress() {
    const {CUST_ACCOUNT_ID} = JSON.parse(localStorage.getItem('user')).profile

    try {
        const data = await axios.get(`${baseURL}/distributors/address/${CUST_ACCOUNT_ID}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetUserList() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile

    try {
        const data = await axios.get(`${baseURL}/internal-users/list/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function CreateAssistantUser(payload) {

    try {
        const data = await axios.post(`${baseURL}/internal-users/create`,payload,{
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function UpdateAssistantUsers(payload,id,distributorID) {

    try {
        const data = await axios.patch(`${baseURL}/internal-users/update/${distributorID}/${id}`,payload,{
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
// ProductList
async function GetProductList(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    let payload=body;
    payload['distributor_id']=String(ACCOUNT_NUMBER)
    try {
        const data = await axios.post(`${baseURL}/categories/list/distributor/products`,payload,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function GetProductsFiters() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile

    try {
        const data = await axios.get(`${baseURL}/categories/product/filters/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function GetProductDetails(id) {
    try {
        const data = await axios.get(`${baseURL}/categories/view/product/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function GetRelatedProducts(payload,id) {
    let body={}
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    body=payload;
    body.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/categories/related/products`,JSON.stringify(body),{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
//wishlist
async function ListwhishList(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/wishlist-collection/list/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function createWishlist(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload = {}
    payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/wishlist-collection/create`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function UpdateWishlist(body,id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.patch(`${baseURL}/wishlist-collection/update/${ACCOUNT_NUMBER}/${id}`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function deleteWishlist(body,id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.delete (`${baseURL}/wishlist-collection/delete/${ACCOUNT_NUMBER}/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function ListwhishListProducts(id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/wishlist/list/${ACCOUNT_NUMBER}/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function removeAllProducts(body,id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.delete(`${baseURL}/wishlist/remove-all/${ACCOUNT_NUMBER}/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function removeParticular(id,deleteID) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.delete(`${baseURL}/wishlist/delete/${ACCOUNT_NUMBER}/${id}/${deleteID}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
// Add-to-wishlist
async function AddTowishlist(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload = {}
    payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/wishlist/add`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function BulkAddProducts (body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let arr=[]
    body.map((item)=>{
        item.distributor_id=ACCOUNT_NUMBER;
        arr.push(item)
    });
    try {
        const data = await axios.post(`${baseURL}/cart/bulk/add`,arr,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
//All products in wishlist
async function AllwhishListProducts() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/wishlist/list-all/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

// CART
async function CartItems(key,key2) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/cart/${key2?'list-cart':'list'}/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function AddToCart(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/cart/add`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function RemoveFromCart(id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.delete(`${baseURL}/cart/delete/${ACCOUNT_NUMBER}/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function AddtoCartFromWishlist(id,collection_id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.post(`${baseURL}/cart/move-to-cart/${ACCOUNT_NUMBER}/${collection_id}/${id}`,{},{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
//calculation
async function CartCalculation(payload,currentpage) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/orders/offer/calculation/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
//Move all products to wishlist
async function moveAlltowishlist(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload = {}
    payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/cart/move-to-wishlist `,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function moveAlltoCartFromWishlist(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload = {}
    payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/cart/move-from-wishlist `,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
// offers
async function OffersList(payload,currentpage) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/offers/list/${ACCOUNT_NUMBER}?page=${currentpage}&limit=10${payload?payload:""}
        `,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
//Create Order
async function CreateOrder(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload = {}
    payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    payload.order_from='Web';
    try {
        const data = await axios.post(`${baseURL}/orders/create`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function GetOfferDetails(id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const code = encodeURIComponent(id)
        const data = await axios.get(`${baseURL}/offers/distributor/get?code=${code}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetBulkOfferDetails(id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const code = encodeURIComponent(id)
        const data = await axios.get(`${baseURL}/bulk-offers/distributor/get?code=${code}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function clearCart(key) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.delete(`${baseURL}/cart${key?'/special':''}/remove-all/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
// offer-bulk-add
async function BulkAddFromOffer(body) {
    try {
        const data = await axios.post(`${baseURL}/cart/bulk/add-from-deal`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function getDealsProducts(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    body.distributor_id=ACCOUNT_NUMBER

    try {
        const data = await axios.post(`${baseURL}/categories/list/deal-sku`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function getBulkDealsProducts(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    body.distributor_id=ACCOUNT_NUMBER

    try {
        const data = await axios.post(`${baseURL}/categories/list/bulk-sku`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function AddSpcialOfferToCart(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/cart/special/add`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function AddSpecialRecurringOfferToCart(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/cart/special-recurring/add`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function AddBulkOfferToCart(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/cart/bulk-offer/add`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function CartSpecialList(deal) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const code = encodeURIComponent(deal)
        const data = await axios.get(`${baseURL}/cart/special/list/${ACCOUNT_NUMBER}?code=${code}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}
async function CartSpecialRecurringList(deal) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const code = encodeURIComponent(deal)
        const data = await axios.get(`${baseURL}/cart/special-recurring/list/${ACCOUNT_NUMBER}?code=${code}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function CartDealList(deal) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/cart/bulk-offer/list/${ACCOUNT_NUMBER}?subscription=${deal}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}


//Raise a ticket
async function RaiseATicket(body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let payload=body;
    payload.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/zendesk-ticket/create`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
//related-deals
async function GetRelatedOffers(payload,id) {
    let body={}
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    body=payload;
    body.distributor_id=ACCOUNT_NUMBER;
    try {
        const data = await axios.post(`${baseURL}/offers/related/deals?record=all`,JSON.stringify(body),{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function OrderList(type,sort,url,search,currentpage,exportval) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    const check= url?.split('&')||[];
    let statusExist=false;
    let statusKey=''
    check.length>0 && check.map((item)=>{
        if(item.split('=')[0]==='status'){
            statusExist=true;
            statusKey=item.split('=')[1]
        }
    })
    const exportKey = exportval === undefined?'list':`${exportval}`;
    let finalUrl=``
    if(statusExist){
        if (url === '') {
            params = '&status=1,2,3,4,5,6,7,8';
        }
        if(!exportKey.includes('pdf'))
            finalUrl=`orders/${exportKey}/${ACCOUNT_NUMBER}${`?sort=${sort}`}${url?`${url}`:''}${search===''?'':`&search=${search}`}&page=${currentpage}&limit=10`
        else finalUrl=`pdf-converter/orders/${ACCOUNT_NUMBER}${`?sort=${sort}`}${url?`${url}`:''}${search===''?'':`&search=${search}`}&page=${currentpage}&limit=10`
    }else{
        if(!exportKey.includes('pdf')) 
            finalUrl=`orders/${exportKey}/${ACCOUNT_NUMBER}?sort=${sort} ${type!=='draft'?'':'&status=0'}${url?`${url}`:''}${search===''?'':`&search=${search}`}&page=${currentpage}&limit=10`
        else finalUrl=`pdf-converter/orders/${ACCOUNT_NUMBER}?sort=${sort} ${type!=='draft'?'':'&status=0'}${url?`${url}`:''}${search===''?'':`&search=${search}`}&page=${currentpage}&limit=10`
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function ViewOrderDetails(id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/orders/get/${ACCOUNT_NUMBER}/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function AcceptOrRejectDraftOrder(payload,id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;

    try {
        const data = await axios.patch(`${baseURL}/orders/order-approval/${ACCOUNT_NUMBER}/${id}`,payload,{
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function handleUploadProfile(payload) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;

    try {
        const data = await axios.patch(`${baseURL}/distributors/update/${ACCOUNT_NUMBER}`,payload,{
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function UpdateAddress(body, order_id) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.patch(`${baseURL}/orders/order-address-update/${ACCOUNT_NUMBER}/${order_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function InvoicesList(currentpage,searchValue,sort,filterUrl,exportval) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    const exportKey = exportval === undefined ? 'list' : `${exportval}`
    let finalUrl= ``
    if(exportval === 'pdf-converter') {
        finalUrl=`${exportKey}/invoices/html-to-pdf/?distributor_ids=${ACCOUNT_NUMBER}&sort=${sort}&page=${currentpage}${searchValue===''?'':`&search=${searchValue}`}${filterUrl?`${filterUrl}`:''}&limit=10`
    }
    else{
        finalUrl=`invoices/${exportKey}/${ACCOUNT_NUMBER}?sort=${sort}&page=${currentpage}${searchValue===''?'':`&search=${searchValue}`}${filterUrl?`${filterUrl}`:''}&limit=10${exportval === undefined ? '&with_category=true' : ''}`
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function ViewInvoicesDetails(invoiceNumber, isPresigned) {
    if (isPresigned) {
        try {
            const data = await axios.get(`${baseURL}/invoices/get/${invoiceNumber}?presigned=true`, { headers: authHeader() });
            return { error: false, data: data.data };
        } catch (error) {
            return { error: true, message: error };
        }
    }
    try {
        const data = await axios.get(`${baseURL}/invoices/get/${invoiceNumber}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function OrderInvoiceDetails(id, distributorId) {
    try {
        const data = await axios.get(`${baseURL}/invoices/get/invoice/${distributorId}/${id}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetResourceCategoryList(limit) {
    try {
        const data = await axios.get(`${baseURL}/resource/categories-list?page=1&limit=${limit || 100}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function ResourceList(currentPage, searchValue, sortType, filterValue) {
    try {
        const data = await axios.get(`${baseURL}/resource/list?status=1&limit=8&page=${currentPage}&sort=${sortType}${searchValue===''?'':`&search=${searchValue}`}${filterValue.length === 0 ? '':`&resource_category_id=${filterValue}`}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function RecentOrderList() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/orders/list/${ACCOUNT_NUMBER}?limit=5&page=1&sort=created_at+desc`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function RecentOrderProducts() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/distributors/dashboard/order-products/${ACCOUNT_NUMBER}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function OrderData(year,date_range) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/distributors/dashboard/values/${ACCOUNT_NUMBER}${year!== ''? `?financial_year=${year}`: ''}${date_range!== '' && date_range!== undefined  ? `?date_range=${date_range}`: ''}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function AdorCashTransaction(query) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/invoices/ador-cash/${ACCOUNT_NUMBER}/list?${query}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}


async function RecentInvoiceList() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/invoices/list/${ACCOUNT_NUMBER}?page=1&limit=5&sort=INVOICE_DATE+desc&with_category=true`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

async function UpdateInvoiceList(invoice_id, indentNo, body) {
    try {
        const data = await axios.patch(`${baseURL}/invoices/update/${indentNo}/${invoice_id}`,body,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

async function DashboardData(id) {
    try {
        const data = await axios.get(`${baseURL}/distributors/dashboard/values/${id}`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function BannerList() {
    try {
        const data = await axios.get(`${baseURL}/promotion/list?active=true`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
        
    }
}

async function NotificationList() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/orders/notification/list/${ACCOUNT_NUMBER}?sort=created_at`,{headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

async function NotificationListStatusUpdate(NotificationId,body) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.patch(`${baseURL}/orders/notification/${ACCOUNT_NUMBER}/${NotificationId}`, body, {headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

async function ClearNotificationList() {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.delete(`${baseURL}/orders/notification/${ACCOUNT_NUMBER}`, {headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

// MIS Reports

async function MISPendingOrderReport(id, currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if(exportSelected === '' || exportSelected === undefined){
        finalUrl=`mis-reports/pending-order/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`
    } else if(exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/pending-order/export?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`
    } else {
        finalUrl=`mis-reports/pending-order-${exportSelected}/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISOutstandingInvoiceDetails(id, currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if(exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/outstanding-invoice/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/outstanding-invoice/export?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    } else {
        finalUrl = `mis-reports/outstanding-invoice-${exportSelected}/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISInvoiceReport(id, currentPage, searchValue, sortType, filterValue, exportSelected) {
    let data = ``
    if (exportSelected === '' || exportSelected === undefined) {
        data = `mis-reports/invoice/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    } else if (exportSelected === 'pdf-converter') {
        data = `pdf-converter/invoice/export?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    } else {
        data = `mis-reports/invoice-${exportSelected}/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    }
    try {
        data = await axios.get(`${baseURL}/${data}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISIndentReport(id, currentPage, sortType, searchValue, filterValue, exportSelected ) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/indent/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/indent-report/export?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    } else {
        finalUrl = `mis-reports/indent-${exportSelected}/list?customer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISViewCustomerWiseOutstandingReport(custId, exportSelected) {
    let finalUrl = ''
    if(exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/customer-wise-outstanding-report/list?customer_code=${custId}&limit=10&page=1`
    } else if(exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/customer-wise-outstanding-report/export?customer_code=${custId}&limit=10&page=1`
    } else {
        finalUrl = `mis-reports/customer-wise-outstanding-report-${exportSelected}/list?customer_code=${custId}&limit=10&page=1`
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

// bulk offer


async function BulkOfferList(currentPage, sortType, searchValue, filterValue) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/bulk-offers/list/${ACCOUNT_NUMBER}?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`, {
            headers:authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}


async function SubscriptionList(currentPage, sortType, searchValue, filterValue) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/bulk-offers/subscription/list?limit=10&distributor_id=${ACCOUNT_NUMBER}&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`, {
            headers:authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

async function SubscriptionGet(subscription) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.get(`${baseURL}/bulk-offers/get/subscription/${ACCOUNT_NUMBER}/${subscription}`, {
            headers:authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}


async function CreateSubscription(code) {
    const {ACCOUNT_NUMBER, PARTY_NAME} = JSON.parse(localStorage.getItem('user')).profile
    try {
        const data = await axios.post(`${baseURL}/bulk-offers/subscription/create`, {'offer':code,"distributor_id": ACCOUNT_NUMBER,"party_name": PARTY_NAME}, {headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

async function ProductPriceList(body) {
    try {
        const data = await axios.post(`${baseURL}/categories/list/price-list-admin`, body, {headers:authHeader()});
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}


async function ZendeskCategoryList() {
    try {
        const data = await axios.get(`${baseURL}/zendesk-ticket/ticket/categories`, {
            headers:authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}


async function SplitItem(payload) {
    try {
        const {ACCOUNT_NUMBER, PARTY_NAME} = JSON.parse(localStorage.getItem('user')).profile
        const data = await axios.post(`${baseURL}/cart/split-item-quantity/${ACCOUNT_NUMBER}`, payload, {
            headers:authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}
// chec eligibility for the  special recurring orrder
async function checkEligibility(offer_code) {
    try {
        const {ACCOUNT_NUMBER, PARTY_NAME} = JSON.parse(localStorage.getItem('user')).profile
        const code = encodeURIComponent(offer_code)
        const data = await axios.get(`${baseURL}/cart/special-recurring/check-eligibility/${ACCOUNT_NUMBER}/${code}`, {
            headers:authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };       
    }
}

const getSignedUrl = async (key, method) => {
    const apiEndPoint = `distributors/s3-presigned-url?method=${method}&key=${key}`
    // const token = await AsyncStorage.getItem('accessToken')

    const apiResponse = await axios.get(`${baseURL}/distributors/s3-presigned-url?method=${method}&key=${key}`, {
        headers:authHeader(),
    });
    if (apiResponse) {
        const cartListApiResponse = apiResponse.data
        if (cartListApiResponse.success_status) {
            return { error: false, res: cartListApiResponse }
        } else return { error: true, message: cartListApiResponse.message }
    } else return { error: true, message: apiResponse.message }
}

const getBlob = async (fileUri) => {
    const resp = await fetch(fileUri);
    const imageBody = await resp.blob();
    return imageBody;
};

async function uploadImages (key, image) {
    // const imageBody = await getBlob(image);
    const data = await getSignedUrl(key, 'post')
    const contentType = image.type || 'application/octet-stream';

    const uploadRes = await fetch(data.res.url, {
        method: "PUT",
        headers: {
            'Content-Type': contentType, // or 'image/jpeg' etc., depending on the file
        },
        body: image,
    });
    if (!uploadRes.ok) {
        const errText = await uploadRes.text();
        throw new Error(`Upload failed: ${errText}`);
    }

    // Return the actual uploaded file URL
    return data.res.url.split('?')[0];
};

// Credit/Debit Details
async function CreditDebitDetailsList(currentPage, searchValue, filterValue, exportSelected) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    let finalUrl = '';
    const searchParam = searchValue ? `&search=${searchValue}` : '';
    const filterParam = filterValue || '';

    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `credit-debit-details/list?distributor_id=${ACCOUNT_NUMBER}&limit=10&page=${currentPage}${searchParam}${filterParam}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/credit-debit-details/html-to-pdf/?distributor_id=${ACCOUNT_NUMBER}&limit=10&page=${currentPage}${searchParam}${filterParam}`;
    } else {
        finalUrl = `credit-debit-details/export-${exportSelected}?distributor_id=${ACCOUNT_NUMBER}&limit=10&page=${currentPage}${searchParam}${filterParam}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

// Export Credit/Debit Details
async function ExportCreditDebitDetails(exportType, selected, filterValue, searchValue) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        // Format date range as DD-MM-YYYY,DD-MM-YYYY
        const dateRange = `${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;

        // Build query parameters
        let queryParams = `distributor_id=${ACCOUNT_NUMBER}&export=${exportType}&date_range=${dateRange}`;

        // Add search parameter if exists
        if (searchValue) {
            queryParams += `&search=${encodeURIComponent(searchValue)}`;
        }

        // Parse filterValue to extract other filter parameters
        // filterValue format: &transaction_type=...&customer_code=...&org_code=...
        if (filterValue) {
            // Remove date_range from filterValue if present (we're using it separately)
            const filterParams = filterValue.split('&').filter((param) => param && !param.includes('date_range'));
            if (filterParams.length > 0) {
                queryParams += `&${filterParams.join('&')}`;
            }
        }

        const finalUrl = `credit-debit-details/export?${queryParams}`;
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response?.data?.message || error.message, data: error.response?.data };
    }
}

async function GetTransactionTypes(page = 1, limit = 50) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/credit-debit-details/transaction-types?distributor_id=${ACCOUNT_NUMBER}&page=${page}&limit=${limit}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetOrganizationCodes(page = 1, limit = 50) {
    const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/credit-debit-details/org-codes?distributor_id=${ACCOUNT_NUMBER}&page=${page}&limit=${limit}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function DistributorList(page, searchValue, filterValue, sort, limit = null) {
    let data;

    try {
        if (searchValue !== '') {
            data = await axios.get(`${baseURL}/distributors/list?search=${encodeURIComponent(searchValue)}&limit=${limit || 10}&page=${page}${sort !== '' ? `&sort=${sort}` : ''}${filterValue === 'all' ? '' : `${filterValue}`}`, { headers: authHeader() });
        } else {
            data = await axios.get(`${baseURL}/distributors/list?limit=${limit || 8}&page=${page}${sort !== '' ? `&sort=${sort}` : ''}${filterValue === 'all' ? '' : `${filterValue}`}`, { headers: authHeader() });
        }

        return { error: false, data: data.data };
    } catch (error) {
        if (error.response?.status === 401) {
            // logout();
        }
        return { error: true, message: error.response?.data?.message };
    }
}

export const distributorService = {
    Getprofile,
    CreateAssistantUser,
    GetUserList,
    UpdateAssistantUsers,
    GetProductList,
    GetProductsFiters,
    GetProductDetails,
    GetRelatedProducts,
    ListwhishList,
    createWishlist,
    UpdateWishlist,
    deleteWishlist,
    ListwhishListProducts,
    removeAllProducts,
    removeParticular,
    AddTowishlist,
    AllwhishListProducts,
    CartItems,
    AddToCart,
    OffersList,
    moveAlltowishlist,
    RemoveFromCart,
    BulkAddProducts,
    CartCalculation,
    CreateOrder,
    GetOfferDetails,
    Getaddress,
    clearCart,
    BulkAddFromOffer,
    getDealsProducts,
    AddSpcialOfferToCart,
    AddSpecialRecurringOfferToCart,
    CartSpecialList,
    CartSpecialRecurringList,
    moveAlltoCartFromWishlist,
    AddtoCartFromWishlist,
    RaiseATicket,
    GetRelatedOffers,
    OrderList,
    ViewOrderDetails,
    AcceptOrRejectDraftOrder,
    handleUploadProfile,
    UpdateAddress,
    InvoicesList,
    ViewInvoicesDetails,
    GetResourceCategoryList,
    ResourceList,
    RecentOrderList,
    RecentInvoiceList,
    DashboardData,
    MISPendingOrderReport,
    MISOutstandingInvoiceDetails,
    MISInvoiceReport,
    MISIndentReport,
    RecentOrderProducts,
    OrderData,
    UpdateInvoiceList,
    MISViewCustomerWiseOutstandingReport,
    AdorCashTransaction,
    OrderInvoiceDetails,
    BannerList,
    NotificationList,
    NotificationListStatusUpdate,
    ClearNotificationList,
    BulkOfferList,
    GetBulkOfferDetails,
    getBulkDealsProducts,
    CartDealList,
    SubscriptionList,
    CreateSubscription,
    AddBulkOfferToCart,
    SubscriptionGet,
    ProductPriceList,
    ZendeskCategoryList,
    UpdateDistributor,
    SplitItem,
    checkEligibility,
    uploadImages,
    getSignedUrl,
    CreditDebitDetailsList,
    ExportCreditDebitDetails,
    GetTransactionTypes,
    GetOrganizationCodes,
    DistributorList
}